// What Find opened last in a project, newest first (APS-322): its empty state lists them under
// "Opened recently". Kept for this tab in sessionStorage, like the sandbox's token; a blocked
// storage keeps them for the page only.
import type { Entry } from './model'

/** An entry Find opened, with the address it went to. */
export interface Opened {
  key: string
  kind: Entry['kind']
  id: string
  title: string
  sub?: string | undefined
  mono?: boolean | undefined
  href: string
}

const MAX = 6
const memory = new Map<string, Opened[]>()
const storageKey = (projectId: string) => `apsio.find.recent.${projectId}`

export function recentIn(projectId: string): Opened[] {
  const kept = memory.get(projectId)
  if (kept) return kept
  try {
    const text = sessionStorage.getItem(storageKey(projectId))
    const list = text ? (JSON.parse(text) as Opened[]) : []
    memory.set(projectId, list)
    return list
  } catch {
    return []
  }
}

export function remember(projectId: string, opened: Opened): void {
  const list = [opened, ...recentIn(projectId).filter((o) => o.key !== opened.key)].slice(0, MAX)
  memory.set(projectId, list)
  try {
    sessionStorage.setItem(storageKey(projectId), JSON.stringify(list))
  } catch {
    // Storage blocked: the list lasts for this page.
  }
}

/** Forgets every project's list (signing out, tests). */
export function forgetRecent(): void {
  memory.clear()
  try {
    for (let i = sessionStorage.length - 1; i >= 0; i--) {
      const k = sessionStorage.key(i)
      if (k?.startsWith('apsio.find.recent.')) sessionStorage.removeItem(k)
    }
  } catch {
    // Nothing to forget.
  }
}
